export default {
  inject: ['showLabel'],

  emits: ['update:modelValue'],

  props: {
    attrs: {
      type: Object,
    },

    modelValue: {
      type: String,
      default: '',
    },

    halfWidth: {
      type: Boolean,
      default: false,
    },

    fieldClass: {
      type: String,
      default: '',
    },

    shouldValidate: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },

    fieldUniqueId() {
      return this.field.uniqueId || this.field.id;
    },

    fieldClasses() {
      return [
        'field',
        this.fieldClass,
        {
          'field--invalid': this.isInvalid,
          'w-1/2': this.halfWidth,
        },
      ];
    },

    ariaDescribedby() {
      return `${this.field.id}-error ${this.field.id}-help`;
    },
  },
};
